module.exports = __webpack_public_path__ + "static/content-logos@2x-00fd58cc80369cf9c07778f81dcfd567.png";